import React, { useMemo } from 'react';
import { Routes as RouterRoutes, Route as RouterRoute } from 'react-router-dom';

import Route from './route';
import RoutesList from './routesList';
import { useAuth } from '../hooks/auth';

function buildRoutesArray(userObject, cultureID) {
    const mainArray = [];
    RoutesList.forEach(item => {
        const array = [];
        const itemMatchesGlobalOrBAT = ((item?.isMenu === false || item?.isMenu === undefined) && !item?.onlyGlobal) ||
            (item?.onlyGlobal && userObject?.companyID == null) ||
            (item?.onlyBATGroup && userObject?.isBATGroup);
        const itemMatchesCulture = item?.allowedCulture == null || item?.allowedCulture?.length === 0 ||
            item?.allowedCulture?.some(culture => String(culture) === String(cultureID));
        if (itemMatchesGlobalOrBAT && itemMatchesCulture && item.path) {
            array.push(item);
        }

        item.childrens?.forEach(child => {
            const childMatchesGlobalOrBAT = ((child?.isMenu === false || child?.isMenu === undefined) && !child?.onlyGlobal) ||
                (child?.onlyGlobal && userObject?.companyID == null) ||
                (child?.onlyBATGroup && userObject?.isBATGroup) ||
                child?.justInfoHolder;
            const childMatchesCulture = child?.allowedCulture == null || child?.allowedCulture?.length === 0 ||
                child?.allowedCulture?.some(culture => String(culture) === String(cultureID));
            if (childMatchesGlobalOrBAT && childMatchesCulture && child.path) {
                array.push(child);
            }
        });
        mainArray.push(...array);
    });
    return mainArray;
}

const Routes = () => {
    const { user } = useAuth();
    const userObject = useMemo(() => {
        try {
            return typeof user === 'string' ? JSON.parse(user || 'null') : user;
        } catch {
            return null;
        }
    }, [user]);

    const cultureID = typeof window !== 'undefined' ? localStorage.getItem('@Thrive:cultureID') : null;

    const mainArray = useMemo(
        () => buildRoutesArray(userObject, cultureID),
        [userObject?.companyID, userObject?.isBATGroup, cultureID]
    );

    return (
        <RouterRoutes>
            {mainArray.map(route => (
                <RouterRoute
                    key={route.path}
                    path={route.path}
                    element={
                        <Route
                            component={route.component}
                            isPrivate={route.isPrivate}
                            allowedRoles={route.allowedRoles}
                            allowedCulture={route.allowedCulture}
                        />
                    }
                />
            ))}
        </RouterRoutes>
    );
};

export default Routes;
